import React, { useState } from "react";
import { loginReq } from "./fetchApi";
import toast from "react-hot-toast";

const Login = ({ colors }) => {
  const [data, setData] = useState({
    email: "",
    password: "",
    loading: false,
  });

  const { email, password, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Vui lòng nhập đầy đủ thông tin!");

    setData({ ...data, loading: true });
    try {
      const res = await loginReq({ email, password });
      if (res && res.token) {
        localStorage.setItem("jwt", JSON.stringify(res));
        toast.success(`Chào mừng trở lại, ${res.user.name}!`);
        setTimeout(() => { window.location.href = "/"; }, 1000);
      } else {
        toast.error(res?.error || "Đăng nhập thất bại!");
        setData({ ...data, loading: false });
      }
    } catch (err) {
      toast.error("Lỗi kết nối máy chủ!");
      setData({ ...data, loading: false });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="small fw-bold mb-2 d-block" style={{ color: colors.textMain }}>Email / Tài khoản</label>
        <input
          type="email"
          name="email"
          value={email}
          onChange={handleChange}
          className="form-control auth-input w-100"
          placeholder="example@handdn.com"
          required
        />
      </div>

      <div className="mb-4 position-relative">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <label className="small fw-bold m-0" style={{ color: colors.textMain }}>Mật khẩu</label>
          <span style={{ fontSize: '12px', color: colors.activeMenu, cursor: 'pointer' }} onClick={() => toast.info("Vui lòng liên hệ Admin")}>
            Quên mật khẩu?
          </span>
        </div>
        <input
          type="password"
          name="password"
          value={password}
          onChange={handleChange}
          className="form-control auth-input w-100"
          placeholder="••••••••"
          required
        />
      </div>

      <button disabled={loading} type="submit" className="auth-btn w-100">
        {loading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ) : (
          "ĐĂNG NHẬP HỆ THỐNG"
        )}
      </button>
    </form>
  );
};

export default Login;